import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {getClientes, getCxC, getPlantillaConvetidad, getPlantillaConvetidadHtml} from "../../services";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    Input,
    ListItemText,
    MenuItem,
    Select,
    Theme,
    Typography,
    useMediaQuery
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import LoadingProgress from "../../components/LoadingProgress";
import {MostrarError} from "../../components/MostrarError";
import {Print, Save, Share} from "@mui/icons-material";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import Strings from "../../assets/strings";
import {useAppSelector} from "../../redux/hooks";
import {IAmortizacion} from "../../redux/types/IPrestamo";
import SelectPlantilla from "../../components/selects/SelectPlantilla";
import {
    buildAmort,
    formatDate,
    hasPermissionTo, htmltoText,
    PERSMISOS,
    setLSLang,
    translateText,
    urlPramsToObj
} from '../../helpers';
import {getTokenInfo, ID_TOKEN_KEY} from "../../services/auth";
import {isMobile} from "../../helpers/browser_detect";
import {downloadBase64, shareBase64} from "../../helpers/downloadFiles";
import StyledCheckbox from "../../components/StyledCheckbox";
import {SlideTransition, TransZoom} from "../../components/transitions";
import {reporteDetallesPrestamo} from "../../makePDF/reporteDetallesPrestamo";
import {reporteAmortizacion} from "../../makePDF/reporteAmortizacion";
import {htmlToPDF} from "../../makePDF/htmlToPDF";

const TranLeft = SlideTransition("left");

const useStyles = makeStyles((theme:Theme) => ({
    topBar:{
        position:"sticky",
        top:0,
        left:0,
        background:theme.palette.grey[800],
        height:40,
        width: "100%",
        color:theme.palette.common.white,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .controls":{
            "& select":{
                "marginRight": "8px",
                "padding": "5px",
                "border": "none !important",
                "background": "#545454",
                "paddingRight": "10px",
                "color": "inherit",
                "outline": "none",
                "textTransform": "uppercase",
                "& option":{
                    "background": "white",
                    color:"black",
                }
            }
        },
        '@media print': {
            display:"none",
        },
    },
    toShow:{
        marginRight: theme.spacing(1),
        "&>div":{
            background: "#545454",
            border: "none !important",
            paddingRight: 10,
            "&::before":{
                display:"none",
            },
            "& svg":{
                color:"white",
            },

            "&>div":{
                padding: "4px 15px !important",
                fontWeight: 500,
                fontSize: "0.875rem",
                textTransform: "uppercase",
                color: "white"
            }
        }
    },
    select: {
        padding: "2px",
        background: "transparent",
        border: "none",
        fontSize: "inherit",
        marginLeft: "6px",
        marginRight: 10,
        color: "inherit",
        "& option":{
            color: "black",
        }
    },
    content:{
        background:"white",
        fontSize: "18px !important",
        pageBreakBefore: "always",
        padding:0,
        "& p":{
            textAlign: "justify",
            color: "black",
            fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
            lineHeight: "30px",
        },
        "& table": {
            tableLayout: "fixed",
            width:"100%",
            "& *":{
                color: "inherit",
                border: "none !important",
                textAlign: "center",
                "& p": {
                    margin: 0,
                    lineHeight: "21px",
                    "&:first-child":{
                        fontWeight: "bold",
                        fontSize: 16,
                        textTransform: "uppercase",
                    }
                }

            },
            "& tr": {
                background: "white !important",
            },
            "& td": {
                paddingBottom: 79,
            }
        },
        "@media print": {
            padding: 0,
        }
    },
    root:{
        '@media print': {
            "&>div":{
                background:"white",
            }
        },
    },
}));

export const MODAL_EXPORT_TYPE={
    CONTRATO: 1,
    DETALLE_PRESTAMO: 2,
    CXC: 3,
    CLIENTE: 4,
    AMORTIZACION: 5,
};


export default function ContratoDialog() {
    const classes = useStyles();
    const navigate = useNavigate()
    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const {state:hState={}, search} = useLocation();
    const {id,type} = hState?.modalExport ?? {};

    //pantilla para contrato
    const [plantillaId, setPlantillaId] = useState<number>()
    const {list: listPlantillas} = useAppSelector(state => state.plantillas);
    useEffect(()=>{
        if(!plantillaId && listPlantillas?.length){
            let porDefecto = listPlantillas.filter(p=>p.tipo === 2).find(p=>!!p.porDefecto);
            if(porDefecto) setPlantillaId(porDefecto.id)
        }
    }, [plantillaId, setPlantillaId, listPlantillas, type])
    //end plnatilla


    const [title, setTitle] = useState<string>("Documento");

    const [data, setData] = useState<any>({});
    const [content, setContent] = useState<any|null>(null);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const [noMostrar, setNoMostrar] = useState<string[]>([]);

    useEffect(() => {
        let query:any = urlPramsToObj(search);
        if(query.t && query.l){
            localStorage.setItem(ID_TOKEN_KEY, query.t);
            let lc = query["l"].split("-");
            setLSLang(lc[0]);
            Strings.setLanguage(lc[0]);

            delete query["t"];
            delete query["l"];
        }


        let req;
        switch (type){
            case "cxc":
                req = getCxC(query?.estado === "incluirCxcAldia");
                setTitle(Strings.cuentasXcobrar+"_"+formatDate(new Date()))
                break
            case MODAL_EXPORT_TYPE.DETALLE_PRESTAMO:
                // req = exportPrestamoDetalle({
                //     id: parseInt(id!),
                //     encabezado: !noMostrar.includes("cabecera"),
                //     foto: !noMostrar.includes("foto"),
                //     total: !noMostrar.includes("total"),
                //     pagos: !noMostrar.includes("pagos"),
                //     amortizacion: !noMostrar.includes("amortizacion")
                // });
                setTitle("Detalle préstamo")
                reporteDetallesPrestamo(parseInt(id!), noMostrar).then(pdfDocGenerator=>{
                    pdfDocGenerator.getBase64(base64=>{
                        setContent("data:application/pdf;base64,"+base64)
                    })
                })
                break
            case MODAL_EXPORT_TYPE.CONTRATO:
                if(plantillaId) {
                    if( !["654", "375"].includes((getTokenInfo() as any)?.CompanyId) ){
                        req = getPlantillaConvetidadHtml(+id!,plantillaId);
                    }else{
                        req = getPlantillaConvetidad(+id!,plantillaId);
                    }
                }
                setTitle(Strings.contrato+"_"+formatDate(new Date()));
                break
            case  MODAL_EXPORT_TYPE.AMORTIZACION:
                setTitle(Strings.amortizacion+"_"+formatDate(new Date()))
                reporteAmortizacion({params:query}).then(pdfDocGenerator=>{
                    return(
                        pdfDocGenerator.getBase64(base64=>{
                            setContent("data:application/pdf;base64,"+base64)
                        })
                    )
                })

                // req = exportAmortizacion({encabezado: !noMostrar.includes("cabecera"),total: !noMostrar.includes("total"),data: query})

                //const {capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha} = query;
              //  let amort:IAmortizacion[] = buildAmort(capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha);

                // setContent(amort);

                break
            case "cliente":
                req = getClientes(parseInt(id!));
                setTitle("Detalle cliente")
                break
            case "amortizacion":
                setTitle(Strings.amortizacion+"_"+formatDate(new Date()))
                const {capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha} = query;
                let amort:IAmortizacion[] = buildAmort(capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha);
                setContent(amort);

                break
            default:
                req = null
        }

        if(req) {
            setLoading(true);
            setError("");
            setContent(null);
            setData({});

            req.then(({data})=>{

                if(type === MODAL_EXPORT_TYPE.CONTRATO) {
                    setData(data)

                    if( !["654", "375"].includes((getTokenInfo() as any)?.CompanyId) ){
                        htmlToPDF(data.contenido, data.tamanoPagina, data.mostrarEncabezado).then(pdfDocGenerator=>{
                            pdfDocGenerator.getBase64((result) => {
                                setContent("data:application/pdf;base64,"+result)
                            })
                        })

                    }else{
                        setContent("data:application/pdf;base64," + data.base64)
                    }
                    return false
                }



                if(typeof data === "object"){
                    let reader = new FileReader();
                    reader.readAsDataURL(data);
                    reader.onloadend = function() {
                        let base64data = reader.result;

                        setContent(base64data as string);
                    }

                }else{
                    setContent(data);
                }
            }).catch(error=>{
                setContent(null);
                setError(error.response?.statusText)
            }).finally(()=>setLoading(false));
        }
    }, [type,id,plantillaId,setContent,setError,search,setTitle,setLoading, noMostrar]);

    const descargar = ()=>{
        //if(isMobile.AndroidWebView()){
        // if(isMobile.anyWebView() && type === "contrato"){
        //     if (isMobile.AndroidWebView()) {
        //         return  (window as any).Android?.printTextAPP(htmltoText(content));
        //     }else if(isMobile.IosWebView()){
        //         return (window as any).webkit?.messageHandlers?.printTextAPP?.postMessage(htmltoText(content));
        //     }
        // }
        downloadBase64(content, title+".pdf")
    }
    const goBack = () => {
        setContent("")
        navigate(-1)
        // let st = {...hState}
        // delete st.modalExport;
        // setContent("")
        // navigate(pathname, {state:st, replace:true})
    }
    const mostrarOpt = () => {
        let opt:string[] = [];

        switch (type) {
            case MODAL_EXPORT_TYPE.DETALLE_PRESTAMO: opt = ["total", "pagos", "amortizacion"];
            break
            case MODAL_EXPORT_TYPE.AMORTIZACION: opt = ["total"];
                break
        }

        return opt
    }
    return (
      <Dialog {...(smVewport ? {TransitionComponent: TranLeft}:{TransitionComponent:TransZoom})} open={!!hState?.modalExport} disableEscapeKeyDown maxWidth={"md"} fullWidth fullScreen={smVewport} scroll={"paper"}
              classes={{root:classes.root}}>
          <TopBarDialog title={title ?? Strings.exportar} onClose={goBack} />

          <div className={classes.topBar}>
              <div>
                  {type === MODAL_EXPORT_TYPE.CONTRATO && hasPermissionTo(PERSMISOS.plantillasActualizar) &&
                      <Button color={"inherit"} onClick={()=>navigate("/editar/plantilla/"+plantillaId)}>{Strings.editar} {Strings.plantilla}</Button>
                  }
                  {/*{type === "contrato" && !!content && <Hidden only={"xs"}>*/}
                  {/*    <Button color={"inherit"} onClick={()=>textToPDF(content,58)}>58mm</Button>*/}
                  {/*    <Button color={"inherit"} onClick={()=>textToPDF(content,80)}>80mm</Button>*/}
                  {/*</Hidden>}*/}
              </div>
              <div className={"controls"}>
                  {/*<FormControlLabel control={<Switch size="small" checked={showCabecera} onChange={(e)=>setShowCabecera(e.target.checked)}/>} label={Strings.cabecera} />*/}
                  {type === MODAL_EXPORT_TYPE.CONTRATO &&
                      <SelectPlantilla
                          value={plantillaId}
                          hideWithoutContent={true}
                          autoDefault={true}
                          onChange={({target}) => {
                              setPlantillaId(target.value? parseInt(target.value):undefined);
                              setError("")
                          }}
                      />
                  }
                  {!!mostrarOpt().length &&
                      <FormControl className={classes.toShow} size={"small"}>
                          <Select
                              multiple
                              value={noMostrar}
                              onChange={({target})=>{
                                  setNoMostrar(target.value as string[])
                              }}
                              input={<Input />}
                              displayEmpty={true}
                              renderValue={() => Strings.mostrar}
                          >
                              {mostrarOpt()?.map((name) => (
                                  <MenuItem key={name} value={name}>

                                      <StyledCheckbox
                                          checked={noMostrar.indexOf(name) === -1}
                                      />

                                      <ListItemText primary={translateText(name)} />
                                  </MenuItem>
                              ))}
                          </Select>
                      </FormControl>
                  }
              </div>
          </div>



          {loading && <LoadingProgress/>}
          <MostrarError errors={error}
                        // action={
                        //       <Button component={Link}  to={{pathname: "/ajustes", hash: "#contrato"}} color="inherit" size="small">
                        //           {Strings.ajustes}
                        //       </Button>
                        // }
          />

          <DialogContent className={classes.content} style={{height:"calc(100vh - 190px)"}}>
                  {(type === MODAL_EXPORT_TYPE.DETALLE_PRESTAMO || type === MODAL_EXPORT_TYPE.CONTRATO || type === MODAL_EXPORT_TYPE.AMORTIZACION ) && !!content &&
                      <>
                        {isMobile.AndroidWebView() ?(
                            <Box textAlign={"center"}>
                                <Typography color={"secondary"}  sx={{textAlign:"center !important",fontSize:20,  p:5}}  >Generado!</Typography>
                                {!!(window as any).ReactNativeWebView && <Button size={"small"} onClick={() => {
                                    let ms = {
                                        action: "showPdf",
                                        payload:  {
                                            base64: content,
                                        }
                                    };
                                    (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))
                                }}>Ver Documento</Button>}
                            </Box>
                            ):(
                                <iframe key={content.slice(-40)} title={title} src={content}  style={{width:"99%", height:"calc(100vh - 199px)", border:"none" }}/>
                        )}
                      </>
                  }
          </DialogContent>
          <DialogActions>
              {/*<Button onClick={goBack} sx={isMobile.anyWebView()  ? {mr:"auto"} : {}} color="warning" variant={"outlined"} startIcon={<Close/>} size={"small"}>{Strings.cerrar}</Button>*/}



              {(["58mm", "80mm"].includes(data.tamanoPagina ?? "")) && (window as any).ReactNativeWebView?(
                  <Button onClick={()=>{
                      let ms = {
                          action: "imprimirTexto",
                          payload:  htmltoText(data.contenido)
                      };

                      (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))

                  }} type="button"  color="primary" size={"small"} variant={"outlined"} startIcon={<Print/>} >
                      {Strings.imprimir}
                  </Button>
              ):(
                  <Button onClick={descargar} type="button"  color="primary" size={"small"} variant={"outlined"} startIcon={<Save/>} >
                      {Strings.guardar}
                  </Button>
              )}


              {isMobile.anyWebView() &&
                  <Button onClick={()=>{
                      shareBase64(content, title, "pdf")
                  }} type="button"  color="primary" size={"small"} variant={"outlined"} startIcon={<Share/>} >
                      {Strings.compartir}
                  </Button>
              }
          </DialogActions>
      </Dialog>
    );
}


